import { render, staticRenderFns } from "./RegFormItem.vue?vue&type=template&id=ae64c930&scoped=true&"
import script from "./RegFormItem.vue?vue&type=script&lang=js&"
export * from "./RegFormItem.vue?vue&type=script&lang=js&"
import style0 from "./RegFormItem.vue?vue&type=style&index=0&id=ae64c930&lang=scss&scoped=true&"
import style1 from "./RegFormItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae64c930",
  null
  
)

export default component.exports